// Shared Framer Motion presets. Import from here — no ad-hoc easings.
// Respect `<MotionConfig reducedMotion="user">` wrapper at root: motion.* components will
// automatically skip transforms in reduced-motion. Counter and custom animate() calls
// must check useReducedMotion() manually.

export const easeOutStrong = [0.16, 1, 0.3, 1];
export const easeInOutStrong = [0.87, 0, 0.13, 1];
export const easeOutCirc = [0, 0.55, 0.45, 1];

// Standard scroll reveal
export const fadeUp = {
    initial: { opacity: 0, y: 60 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-80px" },
    transition: { duration: 0.8, ease: easeOutStrong },
};

export const fadeUpSmall = {
    initial: { opacity: 0, y: 24 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-80px" },
    transition: { duration: 0.6, ease: easeOutStrong },
};

// Bigger reveal for homepage sections
export const fadeUpBold = {
    initial: { opacity: 0, y: 80, filter: "blur(4px)" },
    whileInView: { opacity: 1, y: 0, filter: "blur(0px)" },
    viewport: { once: true, margin: "-80px" },
    transition: { duration: 0.9, ease: easeOutStrong },
};

// Stagger container — trigger children via whileInView
export const staggerContainer = {
    initial: "hidden",
    whileInView: "show",
    viewport: { once: true, margin: "-80px" },
    variants: {
        hidden: {},
        show: { transition: { staggerChildren: 0.08, delayChildren: 0.05 } },
    },
};

export const staggerChild = {
    variants: {
        hidden: { opacity: 0, y: 30 },
        show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: easeOutStrong } },
    },
};

// Card hover — apply to any card
export const cardHover = {
    whileHover: {
        y: -8,
        scale: 1.02,
        boxShadow: "0 20px 40px -12px rgba(124, 107, 255, 0.35)",
        transition: { duration: 0.25, ease: easeOutStrong },
    },
    whileTap: { scale: 0.99, transition: { duration: 0.15 } },
};

// Primary button hover — for `.btn-primary`
export const primaryButtonHover = {
    whileHover: {
        y: -2,
        boxShadow: "0 20px 45px -12px rgba(124, 107, 255, 0.55)",
        transition: { duration: 0.25, ease: easeOutStrong },
    },
    whileTap: { scale: 0.97 },
};

// Page transitions
export const pageTransition = {
    initial: { opacity: 0, y: 24 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -12 },
    transition: { duration: 0.35, ease: easeOutStrong },
};

// Hero word-by-word reveal
export const heroWordContainer = {
    initial: "hidden",
    animate: "show",
    variants: {
        hidden: {},
        show: { transition: { staggerChildren: 0.06, delayChildren: 0.1 } },
    },
};

export const heroWord = (emphasis) => ({
    variants: {
        hidden: { opacity: 0, y: 40 },
        show: {
            opacity: 1,
            y: 0,
            transition: { duration: emphasis ? 0.9 : 0.5, ease: easeOutStrong },
        },
    },
});

// Text mask slide-up (homepage h2)
export const maskWrap = { overflow: "hidden", display: "inline-block", verticalAlign: "top" };
export const maskInner = {
    initial: { y: "100%" },
    whileInView: { y: "0%" },
    viewport: { once: true, margin: "-80px" },
    transition: { duration: 0.8, ease: easeOutStrong },
};

// Cookie banner entrance
export const bannerAnim = {
    initial: { opacity: 0, y: 100 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 100 },
    transition: { duration: 0.5, ease: easeOutStrong },
};

// Logo rotate on hover
export const logoHover = {
    whileHover: {
        rotate: 15,
        transition: { type: "spring", stiffness: 300, damping: 12 },
    },
};
